// TODO - remove becouse of legacy

import React, { useContext, useEffect, useState } from 'react'
import useReactRouter from 'use-react-router'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { Drawer, Table, Layout, PageHeader, Button } from 'antd'
import { CheckOutlined, DownloadOutlined } from '@ant-design/icons'
import notification from 'mrx-notification'
import { GlobalContext } from 'appContexts'
import { Breadcrumbs } from 'components'
import { CampaignsSelect } from 'features/campaigns/components'
import * as rootStyles from 'assets/layoutStyle'
import styles from './FailedFulfillmentReport.module.scss'
import { connector, PropsFromRedux } from './container'

const FailedFulfillmentReport = (props: PropsFromRedux) => {
  const {
    failedFulfillmentReport,
    isLoading,
    isLoadingCsv,
    error,

    fetchFailedFulfillmentReport,
    fetchFailedFulfillmentCsvReport
  } = props

  const { workspaceId } = useContext(GlobalContext)

  const { history } = useReactRouter()

  const [selectedCampaignId, setSelectedCampaignId] = useState<number>()
  const [isVisible, setVisible] = useState(false)

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'Customers Data report error!',
        description: error
      })
    }
  }, [error])

  const handleSubmit = () => {
    fetchFailedFulfillmentReport(selectedCampaignId)
  }

  const handleCampaignChange = (value) => {
    setSelectedCampaignId(value.id)
  }

  const columns = [
    {
      title: 'Order ID',
      render: (_value, record) => <Link to={`/sales/orders?orderId=${record.orderId}`}>{record.orderId}</Link>,
      key: 'orderId'
    },
    {
      title: 'Date',
      dataIndex: 'date',
      render: (record) => moment(record).format('MM/DD/YYYY'),
      key: 'date'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status'
    }
  ]

  const handleExportCSV = async () => {
    const signedUrl = await fetchFailedFulfillmentCsvReport(selectedCampaignId)
    signedUrl && window.open(signedUrl, '_blank')
  }

  return (
    <Layout style={rootStyles.root}>
      <Layout.Header style={rootStyles.header}>
        <PageHeader
          onBack={() => history.goBack()}
          title='Failed Fulfillment Report'
          extra={[
            <div key='1' className={styles.campaignSelect}>
              <CampaignsSelect
                workspaceId={workspaceId}
                initialOption={{ id: 0, name: 'Select Campaign' }}
                onSelect={handleCampaignChange}
              />
            </div>,
            <Button key='2' type='primary' icon={<CheckOutlined />} onClick={handleSubmit} loading={isLoading}>
              Go
            </Button>,
            <Button key='3' icon={<DownloadOutlined />} disabled={isLoadingCsv} loading={isLoadingCsv} onClick={handleExportCSV}>
              CSV
            </Button>
          ]}
        />
      </Layout.Header>
      <Layout.Content style={rootStyles.contentBreadcrumbs}>
        <Breadcrumbs
          items={[
            { title: 'Main', url: '/' },
            { title: 'Reports', url: '/' },
            { title: 'Failed Fulfillment Report', url: '/' }
          ]}
        />
      </Layout.Content>
      <Layout.Content className={styles.contentComponent}>
        <Table
          columns={columns}
          dataSource={failedFulfillmentReport}
          bordered
          rowKey={(record) => record.orderId}
          pagination={false}
          loading={isLoading}
        />
      </Layout.Content>
      <Drawer title='Failed Report Settings' width='400' onClose={() => setVisible(false)} visible={isVisible}>
        <CampaignsSelect workspaceId={workspaceId} initialOption={{ id: 0, name: 'Select a campaign' }} onSelect={handleCampaignChange} />
        <div
          style={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right'
          }}
        >
          <Button type='primary' htmlType='submit' loading={isLoading} onClick={() => setVisible(false)}>
            Close
          </Button>
        </div>
      </Drawer>
    </Layout>
  )
}

export default connector(FailedFulfillmentReport)
